import { Iconify } from '../../../../shared/components/base';
import { routeKeys, pageTitles } from '../../../../shared/utils/constants';

// ----------------------------------------------------------------------
const { admin, bookings, dashboard, list, modules, myLearning, students, support } = routeKeys;

export const adminNavConfig = [
  {
    items: [{ title: pageTitles.home, path: dashboard, icon: <Iconify icon={'eva:home-outline'} /> }],
  },
  {
    items: [
      {
        title: pageTitles.students,
        path: students,
        icon: <Iconify icon={'eva:people-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: pageTitles.modules,
        path: modules,
        icon: <Iconify icon={'eva:layers-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: pageTitles.support,
        path: support + list,
        icon: <Iconify icon={'eva:email-outline'} />,
        // disabled: true,
      },
    ],
  },
];
export const navConfig = [
  {
    items: [{ title: pageTitles.home, path: dashboard, icon: <Iconify icon={'eva:home-outline'} /> }],
  },

  {
    items: [
      {
        title: pageTitles.bookings,
        path: bookings,
        icon: <Iconify icon={'eva:layers-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: pageTitles.modules,
        path: modules,
        icon: <Iconify icon={'eva:layers-outline'} />,
        // disabled: true,
      },
    ],
  },
  {
    items: [
      {
        title: pageTitles.support,
        path: support + list,
        icon: <Iconify icon={'eva:email-outline'} />,
        // disabled: true,
      },
    ],
  },
];
